<template>
  <div class="event-base ccs-fields">
    <modal :title="modalTitle" :subtitle="''"
      v-on:close="switchModal"
      v-if="modal">
      <ImportEvent v-if="modalType === modalTypes.import" v-on:close="switchModal"/>
      <ManualNotification v-if="modalType === modalTypes.manualNotification" v-on:close="switchModal"/>
      <NotificationsPolicies v-if="modalType === modalTypes.policies" v-on:close="switchModal"/>
      <CreateReport v-if="modalType === modalTypes.reports" v-on:close="switchModal"/>
    </modal>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Полное наименование мероприятия
      </div>
      <ccs-input class="ccs-12 field-value" v-model="fieldsValues.full_name"
        v-bind="fieldsDefinitions.full_name" :readOnly="!editing"
        @error="(err) => setFieldError('full_name', err)"/>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Сокращенное наименование мероприятия
      </div>
      <ccs-input class="ccs-12 field-value" v-model="fieldsValues.short_name"
        v-bind="fieldsDefinitions.short_name" :readOnly="!editing"
        @error="(err) => setFieldError('short_name', err)"/>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Дата начала (C1)
      </div>
      <ccs-input class="field-value" v-model="fieldsValues.started_at"
        v-bind="fieldsDefinitions.started_at" :readOnly="!editing"
        @error="(err) => setFieldError('started_at', err)"/>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Дата завершения (C+1)
      </div>
      <ccs-input class="field-value" v-model="fieldsValues.ended_at"
        v-bind="fieldsDefinitions.ended_at" :readOnly="!editing"
        @error="(err) => setFieldError('ended_at', err)"/>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        День C-1
      </div>
      <ccs-input class="field-value" v-model="fieldsValues.day_c_1"
        v-bind="fieldsDefinitions.day_c_1" :readOnly="!editing"
        @error="(err) => setFieldError('day_c_1', err)"/>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Место проведения
      </div>
      <ccs-input class="ccs-12 field-value" v-model="fieldsValues.location"
        v-bind="fieldsDefinitions.location" :readOnly="!editing"
        @error="(err) => setFieldError('location', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div v-if="!editing && permissionsStatus.isEventUpdateAllowed" class="info-button">
        <button class="ccs-button" @click="switchEditing">
          Редактировать поля
        </button>
      </div>
      <div v-if="!editing" class="info-button">
        <button class="ccs-button ccs-button--light" @click="switchModal(modalTypes.policies)">
          Политики уведомлений
        </button>
      </div>
      <div v-if="!editing && permissionsStatus.isEventNotificationCreateAllowed" class="info-button">
        <button class="ccs-button ccs-button--light" @click="switchModal(modalTypes.manualNotification)">
          Новое уведомление
        </button>
      </div>
      <div v-if="!editing && permissionsStatus.isEventImportAllowed" class="info-button">
        <button class="ccs-button ccs-button--light" @click="switchModal(modalTypes.import)">
          Импорт
        </button>
      </div>
      <div v-if="!editing && permissionsStatus.isEventReportCreateAllowed" class="info-button">
        <button class="ccs-button ccs-button--light" @click="switchModal(modalTypes.reports)">
          Отчеты
        </button>
      </div>
      <div v-else class="info-button">
        <button class="ccs-button" @click="confirmEditing">
          Сохранить изменения
        </button>
      </div>
      <div v-if="editing">
        <button class="ccs-button ccs-button--light" @click="cancelEditing">
          Отмена
        </button>
      </div>
    </div>
    <br/>
    <p>Список пользователей</p>
    <br/>
    <modal title="Привязка пользователя" :subtitle="''"
           v-on:close="switchModal"
           v-if="modal">
      <add-user-to-event v-on:close="switchModal"/>
    </modal>
    <div class="users-actions">
      <button v-if="permissionsStatus.isEventUpdateAllowed"
              class="ccs-button ccs-button--white ccs-button--small" @click="switchModal">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Привязать пользователя
      </button>
    </div>
    <ccs-table :data="eventUsers" :columnsDefs="columnsDefs"
               :defaultActions="defaultActions" @delete="removeUser">
      <template v-slot:labels="props">
        <div v-if="!props.row.labels.data[event.id] || props.row.labels.data[event.id].length === 0">
          Не назначены
        </div>
        <div v-else>
          {{ props.row.labels.data[event.id].join(', ') }}
        </div>
      </template>
    </ccs-table>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';

import Input from '@/components/forms/Input.vue';
import Table from '@/components/Table.vue';
import Modal from '@/components/Modal.vue';

import ImportEvent from '@/components/modals/events/ImportEvent.vue';
import CreateReport from '@/components/modals/events/CreateReport.vue';
import ManualNotification from '@/components/modals/events/ManualNotification.vue';
import NotificationsPolicies from '@/components/modals/events/NotificationsPolicies.vue';

import AddUserToEvent from '@/components/modals/events/AddUserToEvent.vue';

export default {
  name: 'BaseInfo',
  mixins: [FormHelper],
  components: {
    'ccs-input': Input,
    'ccs-table': Table,
    Modal,
    ImportEvent,
    CreateReport,
    ManualNotification,
    NotificationsPolicies,
    AddUserToEvent
  },
  data() {
    return {
      modal: false,
      modalType: null,
      modalTypes: {
        manualNotification: 'MANUAL_NOTIFICATION',
        policies: 'POLICIES',
        import: 'IMPORT',
        reports: 'REPORTS',
      },
      titles: {
        manualNotification: 'Новое уведомление',
        policies: 'Политики уведомлений',
        import: 'Импорт',
        reports: 'Отчеты'
      },
      isManualNotificationModal: false,
      editing: false,
      fieldsDefinitions: {
        full_name: {
          isValid: false,
          error: '',
          required: true,
          type: "textarea",
          placeholder: "Введите наименование",
        },
        short_name: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          placeholder: "Введите наименование",
        },
        started_at: {
          isValid: true,
          error: '',
          required: true,
          type: "date",
        },
        ended_at: {
          isValid: true,
          error: '',
          required: true,
          type: "date",
        },
        day_c_1: {
          isValid: true,
          error: '',
          required: true,
          type: "date",
        },
        location: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          placeholder: "Введите место проведения",
        },
      },
      fieldsValues: {
        id: 0,
        full_name: '',
        short_name: '',
        started_at: new Date(),
        ended_at: new Date(),
        day_c_1: new Date(),
        location: '',
      },
      columnsDefs: [
        {
          name: `full_name`,
          title: 'ФИО',
          prop: 'full_name',
        },
        {
          name: `email`,
          title: `Email`,
          prop: `email`,
        },
        {
          name: `labels`,
          title: `Теги`,
          prop: `labels`,
        },
      ],
    };
  },
  computed: {
    ...mapState('events', ['event', 'eventUsers']),
    ...mapState('session', ['permissions']),
    ...mapGetters('session', ['permissionsStatus']),
    modalTitle() {
      switch (this.modalType) {
        case this.modalTypes.manualNotification:
          return this.titles.manualNotification;
        case this.modalTypes.policies:
          return this.titles.policies;
        case this.modalTypes.import:
          return this.titles.import;
        case this.modalTypes.reports:
          return this.titles.reports;
        default:
          return '';
      }
    },
    defaultActions() {
      return {
        delete: this.permissionsStatus.isEventUpdateAllowed,
      };
    },
  },
  methods: {
    ...mapActions('events', ['updateEvent', 'deleteUserFromEvent']),
    async confirmEditing() {
      this.validateForm();
      if (this.isFormValid) {
        try {
          const changedFields = this.getChangedFields(this.event);
          await this.updateEvent({
            ...changedFields,
            id: this.event.id,
          });
          this.$toasted.success('Изменения сохранены');
          this.switchEditing();
        } catch (err) {
          this.showServerValidationErrors(err);
        }
      }
    },
    switchEditing() {
      this.editing = !this.editing;
    },
    cancelEditing() {
      this.resetFieldValues();
      this.switchEditing();
    },
    resetFieldValues() {
      this.fieldsValues = {
        id: this.event.id,
        full_name: this.event.full_name,
        short_name: this.event.short_name,
        started_at: this.event.started_at,
        ended_at: this.event.ended_at,
        day_c_1: this.event.day_c_1,
        location: this.event.location,
      };
    },
    switchModal(modalType = null) {
      if (this.modal) {
        this.modal = false;
        this.modalType = null;
      } else {
        this.modalType = modalType;
        this.modal = true;
      }
    },
    async removeUser(user) {
      try {
        await this.deleteUserFromEvent(user);
        this.$toasted.success('Пользователь отвязан');
      } catch (err) {
        this.$toasted.error(err);
      }
    },
  },
  watch: {
    event: {
      immediate: true,
      handler(event) {
        this.fieldsValues = {
          id: event.id,
          full_name: event.full_name,
          short_name: event.short_name,
          started_at: event.started_at,
          ended_at: event.ended_at,
          day_c_1: event.day_c_1,
          location: event.location,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.event-base {
  min-height: 100%;
  min-width: 100%;
  background: #fff;

  .info-button {
    padding-left: 0;
  }

  .users-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ccs-table {
    margin-top: 20px;
  }

}
</style>
